module.exports = __webpack_public_path__ + "img/Billedbog_Rim_og_regler1.43de0a8b.jpg";